export const mediaBreakpoints = {
  maxMobile: '(max-width: 767px)',
  minTablet: '(min-width: 768px)',
  maxTablet: '(max-width: 1279px)',
  minDesktop: '(min-width: 1280px)',
};

export const BASE_URL = 'https://nameless-reef-47827.herokuapp.com/';
